module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "ILLUSTRATIONS"
    }
  }, [_vm._v("ILLUSTRATIONS.")])]), _vm._v(" "), _c('table', {
    staticClass: "autotable1",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre10"
  }, [_c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "tdl"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "tdl1"
  }, [_vm._v("Persis was at that moment knitting her brows over some papers at a table in Annis’s little attic room")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002#frontis"
    }
  }, [_c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Frontispiece.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "tdl1"
  }, [_vm._v("“Then, my dear, you are wearing your own great-great-grandmother’s gown”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#p084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "tdl1"
  }, [_vm._v("“Please tell Mrs. Chamberlaine that Ruth is safe”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#p148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "tdl1"
  }, [_vm._v("“This is Mary Carter’s grandchild”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#p212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0